export default __webpack_public_path__ + "static/media/Niseko_ogimage1200.26586ad2.jpg";